// Newly created broadcast
export const STATUS_NEW = 1;
// Contact enrollment started
export const STATUS_ENROLLING = 2;
// Broadcast paused
export const STATUS_PAUSED = 3;
// broadcast done
export const STATUS_DONE = 4;
// broadcast stopped by user
export const STATUS_STOPPED = 5;